import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=411996e3&"
import script from "./ProductVariants.vue?vue&type=script&lang=js&"
export * from "./ProductVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports